var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfe7fd"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.844,
    x2: 395.006,
    xlinkHref: "#lg1",
    y1: 85.839,
    y2: 395.001
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8aaadc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8aaadc"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.97,
    x2: 45.795,
    xlinkHref: "#lg2",
    y1: 111.97,
    y2: 147.145
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.263,
    x2: 461.763,
    xlinkHref: "#lg2",
    y1: 103.909,
    y2: 146.409
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8,
    x2: 30.8,
    xlinkHref: "#lg2",
    y1: 259.333,
    y2: 324
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 479.2,
    x2: 479.2,
    xlinkHref: "#lg2",
    y1: 259.333,
    y2: 324
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 380,
    y2: 503.065
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.728,
    x2: 144.003,
    xlinkHref: "#lg1",
    y1: 369.728,
    y2: 144.003
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.333,
    x2: 176.051,
    xlinkHref: "#lg2",
    y1: 299.333,
    y2: 176.051
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.333,
    x2: 330.372,
    xlinkHref: "#lg2",
    y1: 423.333,
    y2: 330.372
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.338,
    x2: 356.027,
    y1: 153.338,
    y2: 356.027
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76ccf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#518ef8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4981f8"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 301,
    y2: 403.078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4071f7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30569f"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.97,
    x2: 139.97,
    xlinkHref: "#lg2",
    y1: 435.03,
    y2: 457.03
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.783,
    x2: 369.832,
    xlinkHref: "#lg2",
    y1: 428.283,
    y2: 457.233
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m505.42 206.69c-1.21-6.28-6.73-10.81-13.13-10.81h-31.27c-5.69 0-10.73-3.61-12.62-8.98-2.46-7.01-5.3-13.85-8.49-20.49-2.46-5.14-1.46-11.26 2.57-15.28l22.1-22.1c4.52-4.53 5.22-11.64 1.63-16.93-9.11-13.44-19.46-25.97-30.89-37.41l-.01-.01c-11.44-11.44-23.97-21.78-37.41-30.89-5.29-3.59-12.4-2.89-16.93 1.63l-22.1 22.1c-4.02 4.03-10.14 5.03-15.28 2.57-6.64-3.19-13.48-6.03-20.49-8.49-5.37-1.89-8.98-6.93-8.98-12.62v-31.27c0-6.4-4.53-11.92-10.81-13.13-15.64-3-31.79-4.58-48.31-4.58s-32.67 1.58-48.31 4.58c-6.28 1.21-10.81 6.73-10.81 13.13v31.27c0 5.69-3.61 10.73-8.98 12.62-7.01 2.46-13.85 5.3-20.49 8.49-5.14 2.46-11.26 1.46-15.28-2.57l-22.1-22.1c-4.53-4.52-11.64-5.22-16.93-1.63-13.44 9.11-25.97 19.46-37.41 30.9-5.72 5.72-11.17 11.71-16.32 17.95-5.16 6.25-10.03 12.74-14.58 19.46-3.59 5.29-2.89 12.4 1.63 16.93l22.1 22.1c4.03 4.02 5.03 10.14 2.57 15.28-3.19 6.64-6.03 13.48-8.49 20.49-1.89 5.37-6.93 8.98-12.62 8.98h-31.27c-6.4 0-11.92 4.53-13.13 10.81-3 15.64-4.58 31.79-4.58 48.31s1.58 32.67 4.58 48.31c1.21 6.28 6.73 10.81 13.13 10.81h31.27c5.69 0 10.73 3.61 12.62 8.98 2.46 7.01 5.3 13.85 8.49 20.49 2.46 5.14 1.46 11.26-2.57 15.28l-22.1 22.1c-4.52 4.53-5.22 11.64-1.63 16.93 9.11 13.44 19.46 25.97 30.9 37.41 5.72 5.72 11.71 11.17 17.95 16.32 6.25 5.16 12.74 10.03 19.46 14.58 5.29 3.59 12.4 2.89 16.93-1.63l22.1-22.1c4.02-4.03 10.14-5.03 15.28-2.57 6.64 3.19 13.48 6.03 20.49 8.49 5.37 1.89 8.98 6.93 8.98 12.62v31.27c0 6.4 4.53 11.92 10.81 13.13 15.64 3 31.79 4.58 48.31 4.58s32.67-1.58 48.31-4.58c6.28-1.21 10.81-6.73 10.81-13.13v-31.27c0-5.69 3.61-10.73 8.98-12.62 7.01-2.46 13.85-5.3 20.49-8.49 5.14-2.46 11.26-1.46 15.28 2.57l22.1 22.1c4.53 4.52 11.64 5.22 16.93 1.63 13.44-9.11 25.97-19.45 37.41-30.89l.01-.01c11.43-11.44 21.78-23.97 30.89-37.41 3.59-5.29 2.89-12.4-1.63-16.93l-22.1-22.1c-4.03-4.02-5.03-10.14-2.57-15.28 3.19-6.64 6.03-13.48 8.49-20.49 1.89-5.37 6.93-8.98 12.62-8.98h31.27c6.4 0 11.92-4.53 13.13-10.81 3-15.64 4.58-31.79 4.58-48.31s-1.58-32.67-4.58-48.31zm-250.42 110.3c-33.77 0-61.15-27.76-61.15-61.99s27.38-61.99 61.15-61.99 61.15 27.76 61.15 61.99-27.38 61.99-61.15 61.99z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m82.49 67.22c-2.65 2.43-5.25 4.92-7.8 7.47-5.72 5.72-11.17 11.71-16.32 17.95-5.16 6.25-10.03 12.74-14.58 19.46-3.59 5.29-2.89 12.4 1.63 16.93l22.1 22.1c4.03 4.02 5.03 10.14 2.57 15.28 0 0 17.82-29.718 35.754-50.953 6.444-7.631 5.961-18.923-1.102-25.986z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.21 112.1c-9.11-13.44-19.46-25.97-30.89-37.41l-.01-.01c-2.55-2.55-5.15-5.04-7.8-7.46l-22.252 22.252c-7.063 7.062-7.546 18.355-1.102 25.986 17.934 21.234 35.754 50.952 35.754 50.952-2.46-5.14-1.46-11.26 2.57-15.28l22.1-22.1c4.52-4.53 5.22-11.64 1.63-16.93z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m61.6 323.02v.08c-1.89-5.37-6.93-8.98-12.62-8.98h-31.27c-6.4 0-11.92-4.53-13.13-10.81-3-15.64-4.58-31.79-4.58-48.31 0-1.89.03-3.78.07-5.67h40.51c2.042 0 4.016.292 5.882.838 2.119.619 3.538 2.59 3.538 4.798v.034c0 23.83 4.09 46.73 11.6 68.02z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 255c0 16.52-1.58 32.67-4.58 48.31-1.21 6.28-6.73 10.81-13.13 10.81h-31.27c-5.69 0-10.73 3.61-12.62 8.98v-.08c7.51-21.29 11.6-44.19 11.6-68.02 0-.011 0-.023 0-.034 0-2.208 1.419-4.178 3.538-4.798 1.866-.545 3.84-.838 5.882-.838h40.51c.04 1.89.07 3.78.07 5.67z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m70.968 346.007c1.196 4.547-.034 9.458-3.448 12.863l-22.1 22.1c-4.52 4.53-5.22 11.64-1.63 16.93 9.11 13.44 19.46 25.97 30.9 37.41 5.72 5.72 11.71 11.17 17.95 16.32 6.25 5.16 12.74 10.03 19.46 14.58 5.29 3.59 12.4 2.89 16.93-1.63l22.1-22.1c4.02-4.03 10.14-5.03 15.28-2.57 6.64 3.19 13.48 6.03 20.49 8.49 5.37 1.89 8.98 6.93 8.98 12.62v31.27c0 6.4 4.53 11.92 10.81 13.13 15.64 3 31.79 4.58 48.31 4.58s32.67-1.58 48.31-4.58c6.28-1.21 10.81-6.73 10.81-13.13v-31.27c0-5.69 3.61-10.73 8.98-12.62 7.01-2.46 13.85-5.3 20.49-8.49 5.14-2.46 11.26-1.46 15.28 2.57l22.1 22.1c4.53 4.52 11.64 5.22 16.93 1.63 13.44-9.11 25.97-19.45 37.41-30.89l.01-.01c11.43-11.44 21.78-23.97 30.89-37.41 3.59-5.29 2.89-12.4-1.63-16.93l-22.1-22.1c-3.414-3.405-4.644-8.316-3.448-12.863z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 81c-95.944 0-174 78.056-174 174s78.056 174 174 174 174-78.056 174-174-78.056-174-174-174zm0 235.99c-33.77 0-61.15-27.76-61.15-61.99s27.38-61.99 61.15-61.99 61.15 27.76 61.15 61.99-27.38 61.99-61.15 61.99z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.4 323.1c1.89-5.37 6.93-8.98 12.62-8.98h31.27c6.4 0 11.92-4.53 13.13-10.81.425-2.218.814-4.449 1.182-6.688l-142.514-142.514c-27.118-28.75-65.541-46.727-108.088-46.727-81.949 0-148.619 66.67-148.619 148.619 0 42.548 17.977 80.971 46.728 108.089l142.514 142.514c2.238-.368 4.469-.757 6.688-1.182 6.28-1.21 10.81-6.73 10.81-13.13v-31.27c0-5.69 3.61-10.73 8.98-12.62 7.01-2.46 13.85-5.3 20.49-8.49 5.14-2.46 11.26-1.46 15.28 2.57l22.1 22.1c4.53 4.52 11.64 5.22 16.93 1.63 13.44-9.11 25.97-19.45 37.41-30.89l.01-.01c11.43-11.44 21.78-23.97 30.89-37.41 3.59-5.29 2.89-12.4-1.63-16.93l-22.1-22.1c-4.03-4.02-5.03-10.14-2.57-15.28 3.189-6.641 6.029-13.481 8.489-20.491zm-193.4-6.11c-33.77 0-61.15-27.76-61.15-61.99s27.38-61.99 61.15-61.99 61.15 27.76 61.15 61.99-27.38 61.99-61.15 61.99z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.09 154.11c-1.24-1.32-2.51-2.61-3.8-3.88 26.18 26.8 42.33 63.43 42.33 103.77 0 81.95-66.67 148.62-148.62 148.62-40.34 0-76.97-16.15-103.77-42.33 1.27 1.29 2.56 2.56 3.88 3.8l142.51 142.51c2.24-.37 4.47-.75 6.69-1.18 6.28-1.21 10.81-6.73 10.81-13.13v-31.27c0-5.69 3.61-10.73 8.98-12.62 7.01-2.46 13.85-5.3 20.49-8.49 5.14-2.46 11.26-1.46 15.28 2.57l22.1 22.1c4.53 4.52 11.64 5.22 16.93 1.63 13.44-9.11 25.97-19.45 37.41-30.89l.01-.01c11.43-11.44 21.78-23.97 30.89-37.41 3.59-5.29 2.89-12.4-1.63-16.93l-22.1-22.1c-4.03-4.02-5.03-10.14-2.57-15.28 3.19-6.64 6.03-13.48 8.49-20.49 1.89-5.37 6.93-8.98 12.62-8.98h31.27c6.4 0 11.92-4.53 13.13-10.81.43-2.22.81-4.45 1.18-6.69z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 403.619c-81.949 0-148.619-66.67-148.619-148.619s66.67-148.619 148.619-148.619 148.619 66.67 148.619 148.619-66.67 148.619-148.619 148.619zm0-252.238c-57.136 0-103.619 46.483-103.619 103.619s46.483 103.619 103.619 103.619 103.619-46.483 103.619-103.619-46.483-103.619-103.619-103.619z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m357.217 272c-8.135 49.076-50.87 86.619-102.217 86.619s-94.082-37.543-102.217-86.619h-45.424c8.463 73.972 71.441 131.619 147.641 131.619s139.178-57.647 147.641-131.619z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m122.126 410.457c19.86 15.88 44.284 29.453 44.284 29.453-5.14-2.46-11.26-1.46-15.28 2.57l-22.1 22.1c-4.53 4.52-11.64 5.22-16.93 1.63-6.72-4.55-13.21-9.42-19.46-14.58-6.491-5.357-12.712-11.039-18.64-17.012 0-.003 0-.005 0-.008l22.75-22.749c6.866-6.867 17.792-7.468 25.376-1.404z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.01 434.62c-.23.23-.46.46-.69.69l-.01.01c-11.44 11.44-23.97 21.78-37.41 30.89-5.29 3.59-12.4 2.89-16.93-1.63l-22.1-22.1c-4.02-4.03-10.14-5.03-15.28-2.57 0 0 24.424-13.573 44.283-29.453 7.584-6.064 18.511-5.463 25.377 1.403z",
    fill: "url(#SVGID_13_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.1183d93ebaae2e18036e8a0c16c3bef5.svg";
export { ForwardRef as ReactComponent };